import React, { useState } from "react";
import { createPortal } from "react-dom";
import { ReactComponent as Close } from 'src/assets/close.svg';
import LoginModal from "./LoginModal";

interface AlertProps {
    title?: string;
    message: string;
    onClose: () => void;
    onConfirm?: () => void;
    onCancel?: () => void;
    confirmText?: string;
    cancelText?: string;
    showCancel?: boolean;
    /** 확인 클릭 시 로그인 모달로 이어지게 할 때 사용 */
    showLoginOnConfirm?: boolean;
}

const Alert: React.FC<AlertProps> = ({
    title,
    message,
    onClose,
    onConfirm,
    onCancel,
    confirmText = "확인",
    cancelText = "취소",
    showCancel = false,
    showLoginOnConfirm = false,
}) => {
    const [showLogin, setShowLogin] = useState(false);

    const handleConfirm = () => {
        onConfirm?.();
        if (showLoginOnConfirm) {
            // onClose()를 먼저 호출하면 컴포넌트가 언마운트돼 setShowLogin이 무시됨
            // → showLogin을 먼저 true로 바꾸고, LoginModal에서 닫힐 때 onClose 호출
            setShowLogin(true);
        } else if (!showCancel) {
            onClose();
        }
    };

    return createPortal(
        <>
            {showLogin ? (
                <LoginModal
                    setNickName={() => {}}
                    token=""
                    setToken={() => {}}
                    onClose={() => { setShowLogin(false); onClose(); }}
                    closeModal={() => { setShowLogin(false); onClose(); }}
                />
            ) : (
                <>
                    {/* 오버레이 */}
                    <div className="overlay" onClick={onClose} />

                    {/* 모달 박스 */}
                    <div className="penpal-alert">
                        {/* Close Button */}
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 w-7 h-7 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors z-20"
                        >
                            <Close className="w-4 h-4 text-gray-400" />
                        </button>

                        <div className="flex flex-col p-8 pt-10 gap-6">

                            {/* Header */}
                            {title && (
                                <div className="text-center">
                                    <h2 className="text-[18px] font-bold text-[#222]">{title}</h2>
                                </div>
                            )}

                            {/* Body */}
                            <div className="text-[#555] text-center text-[15px] font-medium leading-[1.7] whitespace-pre-wrap">
                                {message}
                            </div>

                            {/* Footer - Buttons */}
                            <div className="flex gap-2.5 justify-center">
                                {showCancel && (
                                    <button
                                        onClick={onCancel || onClose}
                                        className="flex-1 h-11 border border-[#e0e0e0] text-[#666] font-semibold rounded-xl hover:bg-gray-50 transition-colors text-[14px]"
                                    >
                                        {cancelText}
                                    </button>
                                )}
                                <button
                                    onClick={handleConfirm}
                                    className="flex-1 h-11 bg-[#19cf7a] hover:bg-[#00b368] transition-colors text-white font-bold rounded-xl shadow-sm text-[14px]"
                                >
                                    {showLoginOnConfirm ? '로그인하기' : confirmText}
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>,
        document.body
    );
};

export default Alert;
